import { toast } from "sonner";
import { getApiErrorMessage, getIntegrationErrorTitle, isOpenAiKeyRelatedError } from "./errors";
import { INTEGRATION_FIX_LABELS } from "./constants";
import type { IntegrationProvider, ReportErrorOptions } from "./types";

type IntegrationFixHandlers = {
  openOpenAiKeyModal: (() => void) | null;
  openIntegrationSettings: ((provider: IntegrationProvider) => void) | null;
  canFixOpenAi: boolean;
  canFixCompanyCam: boolean;
};

let fixHandlers: IntegrationFixHandlers = {
  openOpenAiKeyModal: null,
  openIntegrationSettings: null,
  canFixOpenAi: false,
  canFixCompanyCam: false,
};

export function registerIntegrationFixHandlers(handlers: Partial<IntegrationFixHandlers>) {
  fixHandlers = { ...fixHandlers, ...handlers };
}

function canFix(provider: IntegrationProvider): boolean {
  if (provider === "openai") {
    return fixHandlers.canFixOpenAi && fixHandlers.openOpenAiKeyModal != null;
  }
  return fixHandlers.canFixCompanyCam && fixHandlers.openIntegrationSettings != null;
}

function openFix(provider: IntegrationProvider) {
  if (provider === "openai") {
    fixHandlers.openOpenAiKeyModal?.();
    return;
  }
  fixHandlers.openIntegrationSettings?.(provider);
}

export function reportIntegrationToast({
  error,
  provider,
  fallback,
  title,
  showFixAction,
}: ReportErrorOptions): string {
  const message = getApiErrorMessage(error, fallback);
  const resolvedTitle = title ?? getIntegrationErrorTitle(provider);

  const shouldShowFix =
    showFixAction ?? (provider === "openai" ? isOpenAiKeyRelatedError(error) : true);

  const action =
    shouldShowFix && canFix(provider)
      ? {
          label: INTEGRATION_FIX_LABELS[provider],
          onClick: () => openFix(provider),
        }
      : undefined;

  toast.error(resolvedTitle, {
    description: message,
    action,
  });

  return message;
}
